import _ from 'underscore';
import { useCallback, useEffect } from 'react';

import { onToggleCopilot, toggleCopilotWithMSASignInPopup } from '@bingads-webui-react/msa-copilot-common';

export const useCopilotToggleEventListener = ({
  userName,
  localeId,
  isAADUser,
  isAppBasedAuthEnabled,
  changeLayout,
  logger,
}) => {
  const handler = useCallback(({ detail: customizedEvent }) => {
    const openCopilot = toggleCopilotWithMSASignInPopup({
      userName,
      localeId,
      isAADUser,
      isAppBasedAuthEnabled,
      logger,
      toggleCopilot: () => {
        logger.trace(`[Copilot] Copilot opened via copilotToggleEvent. eventType=${_.get(customizedEvent, 'eventType')}, eventSource=${_.get(customizedEvent, 'eventSource')}`);
        onToggleCopilot({
          changeLayout,
          mode: 'expanded',
          logger,
          customizedEvent,
        });
      },
    });

    openCopilot();
  }, [isAADUser, isAppBasedAuthEnabled, changeLayout, localeId, logger, userName]);

  useEffect(() => {
    document.addEventListener('copilotToggleEvent', handler);

    return () => {
      document.removeEventListener('copilotToggleEvent', handler);
    };
  }, [handler]);
};
